import { render } from "./Vault.vue?vue&type=template&id=754e2cea&scoped=true&ts=true"
import script from "./Vault.vue?vue&type=script&lang=ts"
export * from "./Vault.vue?vue&type=script&lang=ts"

import "./Vault.vue?vue&type=style&index=0&id=754e2cea&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Domingos\\Documents\\GitHub\\staking-fe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754e2cea"]])

export default __exports__